<template>
  <a
    :is="locked ? 'span' : 'a'"
    class="hover-tile"
    :class="{locked: locked}"
    :href="url"
    target="_blank">
    <div class="bg-full bg-image" :style="{backgroundImage: `url('${ikUrl}')`}"/>
    <div class="bg-full hover-tile__hide-hover">
      <slot name="defaultContent"/>
    </div>
    <div class="bg-full hover-tile__show-hover">
      <slot name="hoverContent"/>
    </div>
  </a>
</template>

<script>
import { urlFromAWSUrl } from '@/imagekit/imageurl_from_aws_url'

export default {
  name: 'ImageHoverTile',
  props: {
    url: {
      type: [String, Object],
      required: true,
      validate: function(value) {
        if (typeof value !== 'string' && value.keys !== undefined) {
          let fields = value.keys()
          if (fields.indexOf('name') < 0 || fields.indexOf('params') < 0) {
            return false
          }
        }
        return true
      }
    },
    bgImageUrl: {
      type: String,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ikUrl() {
      return urlFromAWSUrl(this.bgImageUrl, [{ width: 200, q: 80 }])
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/mixins.less';
.hover-tile {
  height: 150px;
  position: relative;
  margin: 10px 0;
  display: block;

  .hover-tile__hide-hover,
  .hover-tile__show-hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
  .hover-tile__hide-hover {
    display: block;
  }
  .hover-tile__show-hover {
    display: none;
    background-color: rgba(0, 0, 0, 0.8);
  }
  &:not(.locked) {
    &:hover {
      .hover-tile__hide-hover {
        display: none;
      }
      .hover-tile__show-hover {
        display: block;
      }
    }
  }
  &.locked {
    cursor: not-allowed;
  }
  .focus-styles {
    outline-offset: 1px;
  }
  &:focus-visible {
    .focus-styles;
  }
  @supports not selector(:focus-visible) {
    &:focus {
      .focus-styles;
    }
  }
}
</style>
